import { render, staticRenderFns } from "./TServPrizeComp.vue?vue&type=template&id=251f1377&"
import script from "./TServPrizeComp.vue?vue&type=script&lang=js&"
export * from "./TServPrizeComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports